import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import Sidebar from "./../global/Sidebar/Sidebar";
import TopBar from "./../global/Topbar/Topbar";
import Breadcrumb from "../components/breadcrum/Breadcrum";
import { tokenExpTime, selectTimeoutEnabled } from "../redux/auth/authSlice";
import { useAppSelector } from "../redux/hooks";
import useSessionGuard from "../Hooks/useSessionGuard";
import useIdleTimeout from "../Hooks/useIdleTimeout";
import SessionTimeoutWarning from "../components/SessionTimeoutWarning/SessionTimeoutWarning";
import { useState } from "react";
import Loading from "../components/LoadingPage/Loading";

const PrivateRoute = () => {
  const tokenExpiryTime = useAppSelector(tokenExpTime);
  const isLoggedIn = useSelector((state: any) => state.auth.isLoggedIn);
  const isSessionTimeoutEnabled = useAppSelector(selectTimeoutEnabled);
  const { showWarning, remainingTime, resetTimer, handleLogout } = useIdleTimeout();
  const { isChecking } = useSessionGuard(tokenExpiryTime, true);

  const [isCollapsed, setIsCollapsed] = useState(
    localStorage.getItem("sidebarCollapsed") === "true"
  );

  const toggleCollapsed = () => {
    localStorage.setItem("sidebarCollapsed", (!isCollapsed).toString());
    setIsCollapsed(!isCollapsed);
  };

  if (isChecking) return <Loading />;

  return isLoggedIn ? (
    <div className={`main-wrapper ${isCollapsed ? "sidebarOpen" : ""}`}>
      <TopBar isCollapsed={isCollapsed} toggleCollapsed={toggleCollapsed} />
      <div className="main" style={{ display: "flex", flex: 1 }}>
        <Sidebar isCollapsed={isCollapsed} />
        <div className="content-wrapper">
          <Breadcrumb />
          <Outlet />
        </div>
      </div>

      {isSessionTimeoutEnabled && (
        <SessionTimeoutWarning
          show={showWarning}
          remainingTime={remainingTime}
          onStayLoggedIn={resetTimer}
          onLogout={handleLogout}
        />
      )}
    </div>
  ) : (
    <Navigate to="/login" replace />
  );
};

export default PrivateRoute;